// Poll cadence for the live snapshot. Kept as slow as is useful: the app is a
// gas-station register/inventory tool, so "near-real-time" every 20s is plenty —
// this alone cuts snapshot traffic ~5x vs the old 4s cadence and stays well
// under Cloudflare's free-tier request budget.
export const POLL_INTERVAL = 20000;

export const SKYAD_CATEGORIES = [
  'General Open Ads',
  'Tab',
  'Quick Break',
  'Closing Soon',
  "We're Closed",
  'Locks',
  'Valentines',
];

export const STORAGE_KEY = 'sg_manager_token';

// Draft caches: the register ticket and the audit count sheet are mirrored into
// localStorage so a refresh, a tab switch, or a stray navigation never loses a
// half-entered shift. Each is cleared automatically once the shift is clocked
// out / the audit is submitted.
export const SHIFT_QTY_KEY = 'sg_shift_qty';
export const SHIFT_NAME_KEY = 'sg_shift_name';
export const AUDIT_COUNTS_KEY = 'sg_audit_counts';
export const AUDIT_NAME_KEY = 'sg_audit_name';

// LS Ball partner landing page. Embedded on the #/partner tab, so the URL only
// lives in one place.
export const PARTNER_URL = 'https://lsball.online/partner/strawberry-gas';